import ForgotPassword from 'features/Authentication/ForgotPassword';

function ForgotPasswordPage() {
  return <ForgotPassword />;
}

export default ForgotPasswordPage;
